// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/" + ({"586": "recorder","621": "profiler",}[chunkId] || chunkId) + "." + {"118": "227bbb3a","33": "fc43c9f1","476": "b1cc8d6d","563": "69201cdb","586": "a8f16312","621": "429344a8","810": "fba8f6f7","838": "0ef17174","857": "2de31704",}[chunkId] + ".chunk.js"
}